import Box from '@material-ui/core/Box';
import { is } from "date-fns/locale";
import React from "react";
import { CloneButton, Edit } from 'react-admin';
import { usePermissions } from "react-admin";

import { useMutateForm } from '../../../api/useMutateForm';
import { ActionsWithBackButton } from '../../../components/actionbars/ActionsWithBackButton';
import { DocumentsFieldBlock } from "../../../components/fields/DocumentsField";
import { SimpleFormAdv } from "../../../components/forms/SimpleFormAdv";
import { AppManagerRoles, UserRole } from "../../../entities";
import { isInArray } from "../../../utils/general";
import TaskForm from '../forms/TaskForm';
import { TaskStatus } from 'entities/TaskStatus';

const ExtraActionButtons = ({ data, hasCloneRecurring, cloneMutableValues }) => (
    hasCloneRecurring && <Box ml={1} display="flex">
        <CloneButton 
            label="Recurring" 
            variant="outlined" 
            basePath='/recurring-tasks/create'
            record={{...data, ...cloneMutableValues}} 
        />
    </Box>
);


export const TaskEdit = (props) => {
    const {permissions} = usePermissions();
	const [mutateForm, state] = useMutateForm("update", 
        props.resource, props.basePath, props.id, {}); // eslint-disable-line

    if(!permissions) return null;

    const actionsProps = {
        hasShow: true,
        hasList: true,
        hasExtraButtons: true,
        hasClone: true,
        hasCloneRecurring: permissions && isInArray(AppManagerRoles, permissions.role)
    };

    return (
        <React.Fragment>
            <Edit 
                {...props} undoable={false}
                actions={
                    <ActionsWithBackButton 
                        {...actionsProps} 
                        ExtraActionButtons={ExtraActionButtons}
                        cloneMutableValues={{
                            reference: null,
                            origin_id: props.id,
                            status: TaskStatus.BOOKED,
                        }}
                    />
                }
            >
                <SimpleFormAdv save={mutateForm}>
                    <TaskForm isEditForm />
                </SimpleFormAdv>
            </Edit>
            <Edit {...props} undoable={false} actions={null}>
                <DocumentsFieldBlock variant="elevation"/>
            </Edit>
        </React.Fragment>
    );
};
